import type { RenderJobDto } from '@app/shared';
import type { Dictionary } from '../i18n';

/** The engine's stage in words (engine README «Ход команды»); unknown → «Собираю». */
export function stageWords(stage: string | null, t: Dictionary): string {
  const s = t.render.stages;
  switch (stage) {
    case null:
    case 'start':
      return s.start;
    case 'align':
      return s.align;
    case 'storyboard':
      return s.storyboard;
    case 'timing':
    case 'compose':
      return s.layout;
    case 'qc':
      return s.qc;
    case 'render':
    case 'slides':
      return s.draw;
    case 'mix':
      return s.mix;
    case 'check':
    case 'frames':
    case 'zip':
      return s.pack;
    case 'done':
      return s.done;
    default:
      return s.other;
  }
}

/** «9,8 МБ», «2 КБ». */
export function formatBytes(n: number): string {
  const mb = n / 1_048_576;
  if (mb >= 1) return `${String(Math.round(mb * 10) / 10).replace('.', ',')} МБ`;
  return `${Math.max(1, Math.round(n / 1024))} КБ`;
}

/**
 * The button after a failed build: where the person goes to fix it (the same as
 * the chat's). A reel is built from «Озвучка», a carousel from «Формат и текст».
 */
export function tellAction(
  job: Pick<RenderJobDto, 'id' | 'draftId' | 'format' | 'tell' | 'refusal'>,
  t: Dictionary,
): { label: string; to: string } {
  const r = t.render.failedAction;
  switch (job.tell) {
    case 'text': {
      const block = job.refusal?.block;
      return { label: r.text, to: `/drafts/${job.draftId}${block ? `?block=${encodeURIComponent(block)}` : ''}` };
    }
    case 'voice':
      return { label: r.voice, to: `/drafts/${job.draftId}/voice` };
    case 'own_voice':
      return { label: r.ownVoice, to: `/drafts/${job.draftId}/own` };
    default:
      return { label: r.again, to: job.format === 'carousel' ? `/drafts/${job.draftId}` : `/drafts/${job.draftId}/voice` };
  }
}

/** `?block=<id>` of the text screen, only when the draft has that block. */
export function blockFromQuery(raw: string | null, blockIds: readonly string[]): string | null {
  return raw && blockIds.includes(raw) ? raw : null;
}
